// Data for DCP Tool Migration
// Extracted from public/tools/dcp-tool/index.html

export const languageOptions = [
    { value: 'XX', text: 'XX - Non-Verbal / No Dialogue' },
    { value: 'AA', text: 'AA - Afar' },
    { value: 'AF', text: 'AF - Afrikaans' },
    { value: 'SQ', text: 'SQ - Albanian' },
    { value: 'GSFR', text: 'GSFR - Alsatian - France' },
    { value: 'AM', text: 'AM - Amharic' },
    { value: 'AR', text: 'AR - Arabic' },
    { value: 'ARQ', text: 'ARQ - Arabic - Algeria' },
    { value: 'ABV', text: 'ABV - Arabic - Bahrain' },
    { value: 'ARZ', text: 'ARZ - Arabic - Egypt' },
    { value: 'ACM', text: 'ACM - Arabic - Iraq' },
    { value: 'AJP', text: 'AJP - Arabic - Jordan' },
    { value: 'ABK', text: 'ABK - Arabic - Kuwait' },
    { value: 'APC', text: 'APC - Arabic - Lebanon' },
    { value: 'AYL', text: 'AYL - Arabic - Libya' },
    { value: 'ARY', text: 'ARY - Arabic - Morocco' },
    { value: 'ACX', text: 'ACX - Arabic - Oman' },
    { value: 'AFQ', text: 'AFQ - Arabic - Qatar' },
    { value: 'ARSA', text: 'ARSA - Arabic - Saudi Arabia' },
    { value: 'ARSY', text: 'ARSY - Arabic - Syria' },
    { value: 'AEB', text: 'AEB - Arabic - Tunisia' },
    { value: 'ARAE', text: 'ARAE - Arabic - United Arab Emirates' },
    { value: 'ARYE', text: 'ARYE - Arabic - Yemen' },
    { value: 'ARP', text: 'ARP - Arapaho' },
    { value: 'HY', text: 'HY - Armenian' },
    { value: 'AS', text: 'AS - Assamese' },
    { value: 'AZ', text: 'AZ - Azerbaijanian' },
    { value: 'AZCY', text: 'AZCY - Azerbaijanian - Cyrillic' },
    { value: 'AZLT', text: 'AZLT - Azerbaijanian - Latin' },
    { value: 'BA', text: 'BA - Bashkir' },
    { value: 'EU', text: 'EU - Euskara (Basque)' },
    { value: 'BE', text: 'BE - Belarusian' },
    { value: 'BN', text: 'BN - Bengali' },
    { value: 'BNIN', text: 'BNIN - Bengali - India' },
    { value: 'BS', text: 'BS - Bosnian' },
    { value: 'BSCY', text: 'BSCY - Bosnian - Cyrillic' },
    { value: 'BR', text: 'BR - Breton' },
    { value: 'BRFR', text: 'BRFR - Breton - France' },
    { value: 'BG', text: 'BG - Bulgarian' },
    { value: 'MY', text: 'MY - Burmese' },
    { value: 'CA', text: 'CA - Catalan' },
    { value: 'CAES', text: 'CAES - Valencian - Spain' },
    { value: 'TZM', text: 'TZM - Central Atlas Tamazight' },
    { value: 'TZMA', text: 'TZMA - Central Atlas Tamazight - Arabic - Morocco' },
    { value: 'TZMD', text: 'TZMD - Central Atlas Tamazight - Latin - Algeria' },
    { value: 'TZMT', text: 'TZMT - Central Atlas Tamazight - Tifinagh' },
    { value: 'TZMM', text: 'TZMM - Central Atlas Tamazight - Tifinagh - Morocco' },
    { value: 'CKB', text: 'CKB - Central Kurdish' },
    { value: 'CKBI', text: 'CKBI - Central Kurdish - Iraq' },
    { value: 'CHR', text: 'CHR - Cherokee' },
    { value: 'ZH', text: 'ZH - Chinese (Generic)' },
    { value: 'YUE', text: 'YUE - Chinese - Cantonese' },
    { value: 'YHK', text: 'YHK - Chinese - Cantonese - Hong Kong' },
    { value: 'CMN', text: 'CMN - Chinese - Mandarin' },
    { value: 'QMS', text: 'QMS - Chinese - Mandarin - Simplified' },
    { value: 'CSCN', text: 'CSCN - Chinese - Mandarin - Simplified - China mainland' },
    { value: 'CSHK', text: 'CSHK - Chinese - Mandarin - Simplified - Hong Kong' },
    { value: 'CSMO', text: 'CSMO - Chinese - Mandarin - Simplified - Macao' },
    { value: 'CSMY', text: 'CSMY - Chinese - Mandarin - Simplified - Malaysia' },
    { value: 'CSSG', text: 'CSSG - Chinese - Mandarin - Simplified - Singapore' },
    { value: 'CSTW', text: 'CSTW - Chinese - Mandarin - Simplified - Taiwan' },
    { value: 'QTM', text: 'QTM - Chinese - Mandarin - Taiwan' },
    { value: 'QMT', text: 'QMT - Chinese - Mandarin - Traditional' },
    { value: 'CTCN', text: 'CTCN - Chinese - Mandarin - Traditional - China mainland' },
    { value: 'CTHK', text: 'CTHK - Chinese - Mandarin - Traditional - Hong Kong' },
    { value: 'CTMO', text: 'CTMO - Chinese - Mandarin - Traditional - Macao' },
    { value: 'CTMY', text: 'CTMY - Chinese - Mandarin - Traditional - Malaysia' },
    { value: 'CTSG', text: 'CTSG - Chinese - Mandarin - Traditional - Singapore' },
    { value: 'CTTW', text: 'CTTW - Chinese - Mandarin - Traditional - Taiwan' },
    { value: 'NAN', text: 'NAN - Chinese - Min Nan' },
    { value: 'ZHS', text: 'ZHS - Chinese - Simplified' },
    { value: 'ZSCN', text: 'ZSCN - Chinese - Simplified - China mainland' },
    { value: 'ZSHK', text: 'ZSHK - Chinese - Simplified - Hong Kong' },
    { value: 'ZSMO', text: 'ZSMO - Chinese - Simplified - Macao' },
    { value: 'ZSMY', text: 'ZSMY - Chinese - Simplified - Malaysia' },
    { value: 'ZSSG', text: 'ZSSG - Chinese - Simplified - Singapore' },
    { value: 'ZSTW', text: 'ZSTW - Chinese - Simplified - Taiwan ' },
    { value: 'ZHT', text: 'ZHT - Chinese - Traditional' },
    { value: 'ZTCN', text: 'ZTCN - Chinese - Traditional - China mainland' },
    { value: 'ZTHK', text: 'ZTHK - Chinese - Traditional - Hong Kong' },
    { value: 'ZTMO', text: 'ZTMO - Chinese - Traditional - Macao SAR' },
    { value: 'ZTMY', text: 'ZTMY - Chinese - Traditional - Malaysia' },
    { value: 'ZTSG', text: 'ZTSG - Chinese - Traditional - Singapore' },
    { value: 'ZTTW', text: 'ZTTW - Chinese - Traditional - Taiwan' },
    { value: 'COM', text: 'COM - Comanche' },
    { value: 'CO', text: 'CO - Corsican' },
    { value: 'COFR', text: 'COFR - Corsican - France' },
    { value: 'HR', text: 'HR - Croatian' },
    { value: 'HRBA', text: 'HRBA - Croatian - Bosnia and Herzegovina' },
    { value: 'CS', text: 'CS - Czech' },
    { value: 'DA', text: 'DA - Danish' },
    { value: 'PRS', text: 'PRS - Dari' },
    { value: 'DV', text: 'DV - Divehi' },
    { value: 'NL', text: 'NL - Dutch' },
    { value: 'VLS', text: 'VLS - Flemish (Dutch - Belgium)' },
    { value: 'DZ', text: 'DZ - Dzongkha - Bhutan' },
    { value: 'BIN', text: 'BIN - Edo' },
    { value: 'EN', text: 'EN - English' },
    { value: 'EAU', text: 'EAU - English - Austrialia' },
    { value: 'EBZ', text: 'EBZ - English - Belize' },
    { value: 'ECA', text: 'ECA - English - Canada' },
    { value: 'ECB', text: 'ECB - English - Caribbean' },
    { value: 'EHK', text: 'EHK - English - Hong Kong SAR' },
    { value: 'EIN', text: 'EIN - English - India' },
    { value: 'EID', text: 'EID - English - Indonesia' },
    { value: 'EIE', text: 'EIE - English - Ireland' },
    { value: 'EJM', text: 'EJM - English - Jamaica' },
    { value: 'EGM', text: 'EGM - English - Malaysia' },
    { value: 'ENZ', text: 'ENZ - English - New Zealand' },
    { value: 'EPH', text: 'EPH - English - Philippines' },
    { value: 'ENS', text: 'ENS - English - Singapore' },
    { value: 'EGZ', text: 'EGZ - English - South Africa' },
    { value: 'ESW', text: 'ESW - English - Sweden' },
    { value: 'EGT', text: 'EGT - English - Trinidad and Tobago' },
    { value: 'EAE', text: 'EAE - English - United Arab Emirates' },
    { value: 'EGB', text: 'EGB - English - United Kingdom' },
    { value: 'EUS', text: 'EUS - English - United States' },
    { value: 'EZW', text: 'EZW - English - Zimbabwe' },
    { value: 'ET', text: 'ET - Estonian' },
    { value: 'FO', text: 'FO - Faroese' },
    { value: 'FIL', text: 'FIL - Filipino' },
    { value: 'FI', text: 'FI - Finnish' },
    { value: 'FR', text: 'FR - French' },
    { value: 'FRBE', text: 'FRBE - French - Belgium' },
    { value: 'FRCM', text: 'FRCM - French - Cameroon' },
    { value: 'QFC', text: 'QFC - French - Canadian' },
    { value: 'FRCR', text: 'FRCR - French - Caribbean' },
    { value: 'FRCI', text: 'FRCI - French - Cote d Ivoire' },
    { value: 'FRHT', text: 'FRHT - French - Haiti' },
    { value: 'FRLU', text: 'FRLU - French - Luxembourg' },
    { value: 'FRML', text: 'FRML - French - Mali' },
    { value: 'FRMC', text: 'FRMC - French - Monaco' },
    { value: 'FRMA', text: 'FRMA - French - Morocco' },
    { value: 'FRRE', text: 'FRRE - French - Reunion' },
    { value: 'FRSN', text: 'FRSN - French - Senegal' },
    { value: 'FRCH', text: 'FRCH - French - Switzerand' },
    { value: 'FRCD', text: 'FRCD - French Congo - DRC' },
    { value: 'FY', text: 'FY - Western Frisian' },
    { value: 'FF', text: 'FF - Fulah' },
    { value: 'FFL', text: 'FFL - Fulah - Latin' },
    { value: 'FFLN', text: 'FFLN - Fulah - Latin - Nigeria' },
    { value: 'FFLS', text: 'FFLS - Fulah - Latin - Senegal' },
    { value: 'FFNG', text: 'FFNG - Fulah - Nigeria' },
    { value: 'GL', text: 'GL - Galician' },
    { value: 'KA', text: 'KA - Georgian' },
    { value: 'DE', text: 'DE - German' },
    { value: 'DEA', text: 'DEA - German - Austria' },
    { value: 'DLI', text: 'DLI - German - Liechtenstein' },
    { value: 'DLU', text: 'DLU - German - Luxembourg' },
    { value: 'GSW', text: 'GSW - German - Swiss' },
    { value: 'DCH', text: 'DCH - German - Switzerland' },
    { value: 'EL', text: 'EL - Greek' },
    { value: 'KL', text: 'KL - Kalaallisut (Greenlandic)' },
    { value: 'GN', text: 'GN - Guarani' },
    { value: 'GU', text: 'GU - Gujarati' },
    { value: 'HA', text: 'HA - Hausa' },
    { value: 'HALT', text: 'HALT - Hausa - Latin' },
    { value: 'HALN', text: 'HALN - Hausa - Latin - Nigeria' },
    { value: 'HAW', text: 'HAW - Hawaiian' },
    { value: 'HE', text: 'HE - Hebrew' },
    { value: 'HI', text: 'HI - Hindi' },
    { value: 'HU', text: 'HU - Hungarian' },
    { value: 'IBB', text: 'IBB - Ibibio' },
    { value: 'IS', text: 'IS - Icelandic' },
    { value: 'IG', text: 'IG - Igbo' },
    { value: 'IND', text: 'IND - Indonesian Bahasa' },
    { value: 'IU', text: 'IU - Inuktitut' },
    { value: 'IUC', text: 'IUC - Inuktitut - Syllabics' },
    { value: 'GA', text: 'GA - Irish' },
    { value: 'IT', text: 'IT - Italian' },
    { value: 'ITCH', text: 'ITCH - Italian - Switzerland' },
    { value: 'JA', text: 'JA - Japanese' },
    { value: 'KN', text: 'KN - Kannada' },
    { value: 'KR', text: 'KR - Kanuri' },
    { value: 'KRNG', text: 'KRNG - Kanuri - Nigeria' },
    { value: 'KS', text: 'KS - Kashmiri' },
    { value: 'KSDI', text: 'KSDI - Kashmiri - Devanagari - India' },
    { value: 'KK', text: 'KK - Kazakh' },
    { value: 'KM', text: 'KM - Khmer' },
    { value: 'QUC', text: 'QUC - K iche' },
    { value: 'RW', text: 'RW - Kinyarwanda' },
    { value: 'KOK', text: 'KOK - Konkani' },
    { value: 'KO', text: 'KO - Korean' },
    { value: 'KY', text: 'KY - Kyrgyz' },
    { value: 'LAD', text: 'LAD - Ladino' },
    { value: 'LO', text: 'LO - Lao' },
    { value: 'LA', text: 'LA - Latin' },
    { value: 'LAVA', text: 'LAVA - Latin - Vatican City' },
    { value: 'LV', text: 'LV - Latvian' },
    { value: 'LN', text: 'LN - Lingala' },
    { value: 'LT', text: 'LT - Lithuanian' },
    { value: 'DSB', text: 'DSB - Lower Sorbian' },
    { value: 'LB', text: 'LB - Luxembourgish' },
    { value: 'MK', text: 'MK - Macedonian' },
    { value: 'MSA', text: 'MSA - Malay Bahasa' },
    { value: 'MSBN', text: 'MSBN - Malay - Brunei' },
    { value: 'MSMY', text: 'MSMY - Malay - Malaysia' },
    { value: 'ML', text: 'ML - Malayalam' },
    { value: 'MT', text: 'MT - Maltese' },
    { value: 'MNI', text: 'MNI - Manipuri - Bangla' },
    { value: 'MNBI', text: 'MNBI - Manipuri - Bangla - India' },
    { value: 'MI', text: 'MI - Maori' },
    { value: 'ARN', text: 'ARN - Mapuche' },
    { value: 'MR', text: 'MR - Marathi' },
    { value: 'MOH', text: 'MOH - Mohawk' },
    { value: 'MN', text: 'MN - Mongolian' },
    { value: 'MNCN', text: 'MNCN - Mongolian - China' },
    { value: 'MNMT', text: 'MNMT - Mongolian - Traditional' },
    { value: 'MNMC', text: 'MNMC - Mongolian - Traditional - China' },
    { value: 'NV', text: 'NV - Navajo' },
    { value: 'NE', text: 'NE - Nepali' },
    { value: 'NEIN', text: 'NEIN - Nepali - India' },
    { value: 'NO', text: 'NO - Norwegian (Generic)' },
    { value: 'NB', text: 'NB - Norwegian Bokmal' },
    { value: 'NN', text: 'NN - Norwegian Nynorsk' },
    { value: 'OC', text: 'OC - Occitan' },
    { value: 'OR', text: 'OR - Odia (Oriya)' },
    { value: 'OM', text: 'OM - Oromo' },
    { value: 'PAP', text: 'PAP - Papiamento' },
    { value: 'PAPC', text: 'PAPC - Papiamento - Caribbean' },
    { value: 'PS', text: 'PS - Pashto' },
    { value: 'FA', text: 'FA - Persian' },
    { value: 'PL', text: 'PL - Polish' },
    { value: 'PT', text: 'PT - Portuguese - European' },
    { value: 'QBP', text: 'QBP - Portuguese - Brazilian' },
    { value: 'PA', text: 'PA - Punjabi' },
    { value: 'PJA', text: 'PJA - Punjabi - Arabic' },
    { value: 'QUZ', text: 'QUZ - Quechua' },
    { value: 'QZB', text: 'QZB - Quechua - Bolivia' },
    { value: 'QZE', text: 'QZE - Quechua - Ecuador' },
    { value: 'QZP', text: 'QZP - Quechua - Peru' },
    { value: 'RO', text: 'RO - Romanian' },
    { value: 'ROMD', text: 'ROMD - Romanian - Moldova' },
    { value: 'RM', text: 'RM - Romansh' },
    { value: 'RU', text: 'RU - Russian' },
    { value: 'RUMD', text: 'RUMD - Russian - Moldova' },
    { value: 'AEC', text: 'AEC - Saidi Arabic' },
    { value: 'SAH', text: 'SAH - Sakha' },
    { value: 'SMI', text: 'SMI - Sami (Generic)' },
    { value: 'SMN', text: 'SMN - Sami - Inari' },
    { value: 'SMJ', text: 'SMJ - Sami - Lule' },
    { value: 'SMJN', text: 'SMJN - Sami - Lule - Norway' },
    { value: 'SE', text: 'SE - Sami - Northern' },
    { value: 'SEFI', text: 'SEFI - Sami - Northern - Finland' },
    { value: 'SENO', text: 'SENO - Sami - Northern - Norway' },
    { value: 'SESE', text: 'SESE - Sami - Northern - Sweden' },
    { value: 'SMS', text: 'SMS - Sami - Skolt' },
    { value: 'SMA', text: 'SMA - Sami - Southern' },
    { value: 'SMAN', text: 'SMAN - Sami - Southern - Norway' },
    { value: 'SM', text: 'SM - Samoan' },
    { value: 'SA', text: 'SA - Sanskrit' },
    { value: 'GD', text: 'GD - Scottish Gaelic' },
    { value: 'SR', text: 'SR - Serbian (Generic)' },
    { value: 'SRCY', text: 'SRCY - Serbian - Cyrillic' },
    { value: 'SRBA', text: 'SRBA - Serbian - Cyrillic - Bosnia and Herzegovina' },
    { value: 'SRCM', text: 'SRCM - Serbian - Cyrillic - Montenegro' },
    { value: 'SRLT', text: 'SRLT - Serbian - Latin' },
    { value: 'SRLB', text: 'SRLB - Serbian - Latin - Bosnia and Herzegovina' },
    { value: 'SRME', text: 'SRME - Serbian - Latin - Montenegro' },
    { value: 'SD', text: 'SD - Sindhi (Generic)' },
    { value: 'SDAR', text: 'SDAR - Sindhi - Arabic' },
    { value: 'SIN', text: 'SIN - Sindhi - Devanagari - India' },
    { value: 'SI', text: 'SI - Sinhala' },
    { value: 'SK', text: 'SK - Slovak' },
    { value: 'SL', text: 'SL - Slovenian' },
    { value: 'SO', text: 'SO - Somali' },
    { value: 'ST', text: 'ST - Sotho - Southern' },
    { value: 'NSO', text: 'NSO - Sotho sa Leboa (Northern Sotho)' },
    { value: 'ES', text: 'ES - Spanish - Castilian' },
    { value: 'QSA', text: 'QSA - Spanish - Argentina' },
    { value: 'QSB', text: 'QSB - Spanish - Bolivia' },
    { value: 'QCL', text: 'QCL - Spanish - Chile' },
    { value: 'QCO', text: 'QCO - Spanish - Colombia' },
    { value: 'QCA', text: 'QCA - Spanish - Costa Rica' },
    { value: 'QCU', text: 'QCU - Spanish - Cuba' },
    { value: 'QSD', text: 'QSD - Spanish - Dominican Republic' },
    { value: 'QSE', text: 'QSE - Spanish - Ecuador' },
    { value: 'QSL', text: 'QSL - Spanish - El Salvador' },
    { value: 'QGU', text: 'QGU - Spanish - Guatemala' },
    { value: 'QSH', text: 'QSH - Spanish - Honduras' },
    { value: 'LAS', text: 'LAS - Spanish - Latin America' },
    { value: 'QSM', text: 'QSM - Spanish - Mexican' },
    { value: 'QNI', text: 'QNI - Spanish - Nicaragua' },
    { value: 'QPA', text: 'QPA - Spanish - Panama' },
    { value: 'QPY', text: 'QPY - Spanish - Paraguay' },
    { value: 'QPE', text: 'QPE - Spanish - Peru' },
    { value: 'QPR', text: 'QPR - Spanish - Puerto Rico' },
    { value: 'QUS', text: 'QUS - Spanish - United States' },
    { value: 'QUY', text: 'QUY - Spanish - Uruguay' },
    { value: 'QVE', text: 'QVE - Spanish - Venezuela' },
    { value: 'SW', text: 'SW - Swahili' },
    { value: 'SWKE', text: 'SWKE - Swahili - Kenya' },
    { value: 'SV', text: 'SV - Swedish' },
    { value: 'SVF', text: 'SVF - Swedish - Finland' },
    { value: 'SYR', text: 'SYR - Syriac' },
    { value: 'SYSY', text: 'SYSY - Syriac - Syria' },
    { value: 'TL', text: 'TL - Tagalog' },
    { value: 'TG', text: 'TG - Tajik (Generic)' },
    { value: 'TGCY', text: 'TGCY - Tajik - Cyrillic' },
    { value: 'TGCT', text: 'TGCT - Tajik - Cyrillic - Tajikistan' },
    { value: 'TA', text: 'TA - Tamil' },
    { value: 'TT', text: 'TT - Tatar' },
    { value: 'TE', text: 'TE - Telugu' },
    { value: 'TH', text: 'TH - Thai' },
    { value: 'BO', text: 'BO - Tibetan' },
    { value: 'TI', text: 'TI - Tigrinya' },
    { value: 'TS', text: 'TS - Tsonga' },
    { value: 'TN', text: 'TN - Tswana' },
    { value: 'TNBW', text: 'TNBW - Tswana - Botswana' },
    { value: 'TR', text: 'TR - Turkish' },
    { value: 'TK', text: 'TK - Turkmen' },
    { value: 'UK', text: 'UK - Ukranian' },
    { value: 'HSB', text: 'HSB - Upper Sorbian' },
    { value: 'UR', text: 'UR - Urdu' },
    { value: 'UG', text: 'UG - Uyghur' },
    { value: 'UZ', text: 'UZ - Uzbek' },
    { value: 'VE', text: 'VE - Venda' },
    { value: 'VI', text: 'VI - Vietnamese' },
    { value: 'CY', text: 'CY - Welsh' },
    { value: 'WO', text: 'WO - Wolof' },
    { value: 'XH', text: 'XH - Xhosa' },
    { value: 'II', text: 'II - Yi' },
    { value: 'YI', text: 'YI - Yiddish' },
    { value: 'YO', text: 'YO - Yoruba' },
    { value: 'ZU', text: 'ZU - Zulu' },
    { value: 'UND', text: 'UND - Unknown Language' },
];

export const territoryOptions = [
    { value: 'AD', text: 'Andorra' },
    { value: 'AE', text: 'United Arab Emirates' },
    { value: 'AF', text: 'Afghanistan' },
    { value: 'AG', text: 'Antigua and Barbuda' },
    { value: 'AI', text: 'Anguilla' },
    { value: 'AL', text: 'Albania' },
    { value: 'AM', text: 'Armenia' },
    { value: 'ANT', text: 'Netherlands Antilles' },
    { value: 'AO', text: 'Angola' },
    { value: 'AQ', text: 'Antarctica' },
    { value: 'AR', text: 'Argentina' },
    { value: 'AS', text: 'American Samoa' },
    { value: 'AT', text: 'Austria' },
    { value: 'AU', text: 'Australia' },
    { value: 'AW', text: 'Aruba' },
    { value: 'AX', text: 'Aland Islands' },
    { value: 'AZ', text: 'Azerbaijan' },
    { value: 'BA', text: 'Bosnia and Herzegovina' },
    { value: 'BD', text: 'Bangladesh' },
    { value: 'BE', text: 'Belgium' },
    { value: 'BF', text: 'Burkina Faso' },
    { value: 'BG', text: 'Bulgaria' },
    { value: 'BH', text: 'Bahrain' },
    { value: 'BI', text: 'Burundi' },
    { value: 'BJ', text: 'Benin' },
    { value: 'BL', text: 'Saint Barthélemy' },
    { value: 'BM', text: 'Bermuda' },
    { value: 'BN', text: 'Brunei Darussalam' },
    { value: 'BO', text: 'Bolivia' },
    { value: 'BQ', text: 'Bonaire, Saint Eustatius and Saba' },
    { value: 'BR', text: 'Brazil' },
    { value: 'BS', text: 'Bahamas' },
    { value: 'BT', text: 'Bhutan' },
    { value: 'BV', text: 'Bouvet Island' },
    { value: 'BW', text: 'Botswana' },
    { value: 'BY', text: 'Belarus' },
    { value: 'BZ', text: 'Belize' },
    { value: 'CA', text: 'Canada' },
    { value: 'CC', text: 'Cocos Islands' },
    { value: 'CD', text: 'Congo, the Democratic Republic of the' },
    { value: 'CF', text: 'Central African Republic' },
    { value: 'CG', text: 'Congo' },
    { value: 'CH', text: 'Switzerland' },
    { value: 'CI', text: 'Cote D\'Ivoire' },
    { value: 'CK', text: 'Cook Islands' },
    { value: 'CL', text: 'Chile' },
    { value: 'CM', text: 'Cameroon' },
    { value: 'CN', text: 'China Mainland' },
    { value: 'CO', text: 'Colombia' },
    { value: 'CR', text: 'Costa Rica' },
    { value: 'CS', text: 'Serbia' },
    { value: 'CU', text: 'Cuba' },
    { value: 'CUW', text: 'Curacao' },
    { value: 'CV', text: 'Cape Verde' },
    { value: 'CX', text: 'Christmas Island' },
    { value: 'CY', text: 'Cyprus' },
    { value: 'CZ', text: 'Czech Republic' },
    { value: 'DE', text: 'Germany' },
    { value: 'DJ', text: 'Djibouti' },
    { value: 'DK', text: 'Denmark' },
    { value: 'DM', text: 'Dominica' },
    { value: 'DO', text: 'Dominican Republic' },
    { value: 'DU', text: 'Dubai' },
    { value: 'DZ', text: 'Algeria' },
    { value: 'EC', text: 'Ecuador' },
    { value: 'EE', text: 'Estonia' },
    { value: 'EG', text: 'Egypt' },
    { value: 'ER', text: 'Eritrea' },
    { value: 'ES', text: 'Spain' },
    { value: 'ET', text: 'Ethiopia' },
    { value: 'FI', text: 'Finland' },
    { value: 'FJ', text: 'Fiji' },
    { value: 'FK', text: 'Falkland Islands' },
    { value: 'FM', text: 'Micronesia' },
    { value: 'FO', text: 'Faeroe Islands' },
    { value: 'FR', text: 'France' },
    { value: 'GA', text: 'Gabon' },
    { value: 'GD', text: 'Grenada' },
    { value: 'GE', text: 'Georgia' },
    { value: 'GF', text: 'French Guiana' },
    { value: 'GG', text: 'Guernsey' },
    { value: 'GH', text: 'Ghana' },
    { value: 'GI', text: 'Gibraltar' },
    { value: 'GL', text: 'Greenland' },
    { value: 'GM', text: 'Gambia' },
    { value: 'GN', text: 'Guinea' },
    { value: 'GP', text: 'Guadeloupe' },
    { value: 'GQ', text: 'Equatorial Guinea' },
    { value: 'GR', text: 'Greece' },
    { value: 'GS', text: 'South Georgia and the South Sandwich Islands' },
    { value: 'GT', text: 'Guatemala' },
    { value: 'GU', text: 'Guam' },
    { value: 'GW', text: 'Guinea-Bissau' },
    { value: 'GY', text: 'Guyana' },
    { value: 'HK', text: 'Hong Kong' },
    { value: 'HM', text: 'Heard and McDonald Islands' },
    { value: 'HN', text: 'Honduras' },
    { value: 'HR', text: 'Croatia' },
    { value: 'HT', text: 'Haiti' },
    { value: 'HU', text: 'Hungary' },
    { value: 'ID', text: 'Indonesia' },
    { value: 'IE', text: 'Ireland' },
    { value: 'IL', text: 'Israel' },
    { value: 'IM', text: 'Isle of Man' },
    { value: 'IN', text: 'India' },
    { value: 'INT', text: 'International' },
    { value: 'IO', text: 'British Indian Ocean Territory' },
    { value: 'IQ', text: 'Iraq' },
    { value: 'IR', text: 'Iran' },
    { value: 'IS', text: 'Iceland' },
    { value: 'IT', text: 'Italy' },
    { value: 'JE', text: 'Jersey' },
    { value: 'JM', text: 'Jamaica' },
    { value: 'JO', text: 'Jordan' },
    { value: 'JP', text: 'Japan' },
    { value: 'KE', text: 'Kenya' },
    { value: 'KG', text: 'Kyrgyzstan' },
    { value: 'KH', text: 'Cambodia' },
    { value: 'KI', text: 'Kiribati' },
    { value: 'KM', text: 'Comoros' },
    { value: 'KN', text: 'St. Kitts and Nevis' },
    { value: 'KP', text: 'North Korea' },
    { value: 'KR', text: 'South Korea' },
    { value: 'KW', text: 'Kuwait' },
    { value: 'KY', text: 'Cayman Islands' },
    { value: 'KZ', text: 'Kazakhstan' },
    { value: 'LA', text: 'Lao People\'s Democratic Republic' },
    { value: 'LAS', text: 'Latin America' },
    { value: 'LB', text: 'Lebanon' },
    { value: 'LC', text: 'St. Lucia' },
    { value: 'LI', text: 'Liechtenstein' },
    { value: 'LK', text: 'Sri Lanka' },
    { value: 'LR', text: 'Liberia' },
    { value: 'LS', text: 'Lesotho' },
    { value: 'LT', text: 'Lithuania' },
    { value: 'LU', text: 'Luxembourg' },
    { value: 'LV', text: 'Latvia' },
    { value: 'LY', text: 'Libyan Arab Jamahiriya' },
    { value: 'MA', text: 'Morocco' },
    { value: 'MC', text: 'Monaco' },
    { value: 'MD', text: 'Moldova' },
    { value: 'ME', text: 'Montenegro' },
    { value: 'MF', text: 'Saint Martin' },
    { value: 'MG', text: 'Madagascar' },
    { value: 'MH', text: 'Marshall Islands' },
    { value: 'MK', text: 'Macedonia' },
    { value: 'ML', text: 'Mali' },
    { value: 'MM', text: 'Myanmar' },
    { value: 'MN', text: 'Mongolia' },
    { value: 'MO', text: 'Macao' },
    { value: 'MP', text: 'Northern Mariana Islands' },
    { value: 'MQ', text: 'Martinique' },
    { value: 'MR', text: 'Mauritania' },
    { value: 'MS', text: 'Montserrat' },
    { value: 'MT', text: 'Malta' },
    { value: 'MU', text: 'Mauritius' },
    { value: 'MV', text: 'Maldives' },
    { value: 'MW', text: 'Malawi' },
    { value: 'MX', text: 'Mexico' },
    { value: 'MY', text: 'Malaysia' },
    { value: 'MZ', text: 'Mozambique' },
    { value: 'NA', text: 'Namibia' },
    { value: 'NAM', text: 'North America' },
    { value: 'NC', text: 'New Caledonia' },
    { value: 'NE', text: 'Niger' },
    { value: 'NF', text: 'Norfolk Island' },
    { value: 'NG', text: 'Nigeria' },
    { value: 'NI', text: 'Nicaragua' },
    { value: 'NL', text: 'Netherlands' },
    { value: 'NO', text: 'Norway' },
    { value: 'NP', text: 'Nepal' },
    { value: 'NR', text: 'Nauru' },
    { value: 'NU', text: 'Niue' },
    { value: 'NZ', text: 'New Zealand' },
    { value: 'OM', text: 'Oman' },
    { value: 'PA', text: 'Panama' },
    { value: 'PE', text: 'Peru' },
    { value: 'PF', text: 'French Polynesia' },
    { value: 'PG', text: 'Papua New Guinea' },
    { value: 'PH', text: 'Philippines' },
    { value: 'PK', text: 'Pakistan' },
    { value: 'PL', text: 'Poland' },
    { value: 'PM', text: 'St. Pierre and Miquelon' },
    { value: 'PN', text: 'Pitcairn Island' },
    { value: 'PR', text: 'Puerto Rico' },
    { value: 'PS', text: 'Palestinian Territory' },
    { value: 'PT', text: 'Portugal' },
    { value: 'PW', text: 'Palau' },
    { value: 'PY', text: 'Paraguay' },
    { value: 'QA', text: 'Qatar' },
    { value: 'RE', text: 'Reunion' },
    { value: 'RO', text: 'Romania' },
    { value: 'RU', text: 'Russia' },
    { value: 'RW', text: 'Rwanda' },
    { value: 'SA', text: 'Saudi Arabia' },
    { value: 'SB', text: 'Solomon Islands' },
    { value: 'SC', text: 'Seychelles' },
    { value: 'SD', text: 'Sudan' },
    { value: 'SE', text: 'Sweden' },
    { value: 'SG', text: 'Singapore' },
    { value: 'SH', text: 'St. Helena' },
    { value: 'SI', text: 'Slovenia' },
    { value: 'SJ', text: 'Svalbard & Jan Mayen Islands' },
    { value: 'SK', text: 'Slovakia' },
    { value: 'SL', text: 'Sierra Leone' },
    { value: 'SM', text: 'San Marino' },
    { value: 'SN', text: 'Senegal' },
    { value: 'SO', text: 'Somali' },
    { value: 'SR', text: 'Suriname' },
    { value: 'ST', text: 'Sao Tome and Principe' },
    { value: 'SV', text: 'El Salvador' },
    { value: 'SX', text: 'Sint Maarten' },
    { value: 'SY', text: 'Syrian Arab Republic' },
    { value: 'SZ', text: 'Eswatini' },
    { value: 'TC', text: 'Turks and Caicos Islands' },
    { value: 'TD', text: 'Chad' },
    { value: 'TF', text: 'French Southern Territories' },
    { value: 'TG', text: 'Togo' },
    { value: 'TH', text: 'Thailand' },
    { value: 'TJ', text: 'Tajikistan' },
    { value: 'TK', text: 'Tokelau' },
    { value: 'TL', text: 'Timor-Leste' },
    { value: 'TM', text: 'Turkmenistan' },
    { value: 'TN', text: 'Tunisia' },
    { value: 'TO', text: 'Tonga' },
    { value: 'TR', text: 'Türkiye' },
    { value: 'TT', text: 'Trinidad' },
    { value: 'TV', text: 'Tuvalu' },
    { value: 'TW', text: 'Taiwan' },
    { value: 'TZ', text: 'Tanzania' },
    { value: 'UA', text: 'Ukraine' },
    { value: 'UG', text: 'Uganda' },
    { value: 'UK', text: 'United Kingdom' },
    { value: 'UM', text: 'United States Minor Outlying Islands' },
    { value: 'US', text: 'United States' },
    { value: 'UY', text: 'Uruguay' },
    { value: 'UZ', text: 'Uzbekistan' },
    { value: 'VA', text: 'Vatican City State' },
    { value: 'VC', text: 'St. Vincent and the Grenadines' },
    { value: 'VE', text: 'Venezuela' },
    { value: 'VG', text: 'British Virgin Islands' },
    { value: 'VI', text: 'US Virgin Islands' },
    { value: 'VN', text: 'Vietnam' },
    { value: 'VU', text: 'Vanuatu' },
    { value: 'WF', text: 'Wallis and Futuna Islands' },
    { value: 'WS', text: 'Samoa' },
    { value: 'XC', text: 'Crimea' },
    { value: 'YT', text: 'Mayotte' },
    { value: 'ZA', text: 'South Africa' },
    { value: 'ZK', text: 'Kosovo' }
];

export const commonTerritoryOptions = [
    { value: 'WW', text: 'Worldwide' },
    { value: 'EU', text: 'Europe' },
    { value: 'INT', text: 'International' },
    { value: 'LAS', text: 'Latin America' },
    { value: 'NAM', text: 'North America' },
];
